import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import styled from "@emotion/styled"

interface CardProps {
    icon?: React.ReactNode
    title: string
    subtitle?: React.ReactNode | string
    onClick?: () => void
}

export const Card: React.FC<CardProps> = ({icon, title, subtitle, onClick}) => (
  <CardContainer onClick={onClick}>
    <Stack direction="row" spacing={2} justifyContent="left" alignItems="center">
      { icon && icon }
      <Stack direction="column" spacing={0.2} justifyContent="center">
        <Typography style={{display: "flex", alignItems: "center"}} variant="h6">{title}</Typography>
        {subtitle && <Typography style={{display: "flex", alignItems: "center", color: "#333"}} variant="body1">{subtitle}</Typography> }
      </Stack>
    </Stack>
  </CardContainer>
)

const CardContainer = styled.div`
background: #fff;
border: 2px solid transparent;
border-radius: 5px;
box-shadow: 0 1px 4px 0 rgb(38 38 38 / 30%);
cursor: pointer;
display: flex;
flex-flow: row nowrap;
margin: 0 0 8px;
max-width: 440px;
outline: 0;
padding: 24px;
text-decoration: none;
transition: border-color .2s;
&:hover {
  border-color: #005aa4;
}
`